var render, staticRenderFns
import script from "./glOperateMenu.vue?vue&type=script&lang=js"
export * from "./glOperateMenu.vue?vue&type=script&lang=js"
import style0 from "./glOperateMenu.vue?vue&type=style&index=0&id=ab39f4b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab39f4b4",
  null
  
)

export default component.exports